<div class="pnf-container" [attr.data-testid]="ELEMENT_IDS['page']">
  <img class="pnf-img" src="assets/images/page_not_found.png" alt="" [attr.data-testid]="ELEMENT_IDS['img_illustration']" />
  <div class="text-container" [attr.data-testid]="ELEMENT_IDS['cnt_text']">
    <h5 [attr.data-testid]="ELEMENT_IDS['lbl_title']">Page not found.</h5>
    <h6 [attr.data-testid]="ELEMENT_IDS['lbl_subtitle']">The page requested does not exists or you don't have access to it.</h6>
  </div>
  <app-custom-button text="Back to home" [routerLink]="'/'" [elementId]="ELEMENT_IDS['btn_back_to_home']"></app-custom-button>
</div>
